import { render, staticRenderFns } from "./UnifiedPatient.vue?vue&type=template&id=fe69ad22&scoped=true"
import script from "./UnifiedPatient.vue?vue&type=script&lang=js"
export * from "./UnifiedPatient.vue?vue&type=script&lang=js"
import style0 from "./UnifiedPatient.vue?vue&type=style&index=0&id=fe69ad22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe69ad22",
  null
  
)

export default component.exports